<div>
  <div class="card p-0 pt-4 mb-0">
    <div class="flex flex-column mx-4 mb-3">
      <div class="flex flex-column sm:flex-row justify-content-start sm:justify-content-between">
        <p class="inline-block text-4xl flex-order-1 sm:flex-order-0">
          003020A
        </p>
        <div class="flex-order-0 sm:flex-order-1">
          <button pButton pRipple class="mr-2 p-button-primary mt-1 mb-3 sm:mb-0 w-full sm:w-auto"
                  label="{{'common.edit' | transloco}}" icon="pi pi-pencil"></button>
        </div>
      </div>
      <div>
        <p>Sensor de temperatura</p>
      </div>
    </div>
    <div>
      <p-tabMenu class="hidden xl:inline" [model]="tabs" [activeItem]="activeTab"></p-tabMenu>
      <p-tabMenu class="xl:hidden" [model]="tabs" [activeItem]="activeTab">
        <ng-template pTemplate="item" let-item let-i="index">
          <i [className]="item.icon"></i>
        </ng-template>
      </p-tabMenu>
    </div>
  </div>
  <div class="grid" style="margin-top: 8px">
    <div class="col-12 xl:col-8 pb-0">
      <div class="card main-height">
        <div class="card-header pt-1"><h4 class="mb-1">{{'preview.deviceInfo' | transloco}}</h4></div>
        <hr>
        <table class="details-table striped-table">
          <tr>
            <td class="p-3 bold">{{'preview.uuid' | transloco}}</td>
            <td>5ab98138-846d-4a1f-8b4f-757a70e93545</td>
          </tr>
          <tr><td class="p-3 bold">{{'preview.tenant' | transloco}}</td><td>IoTsens</td></tr>
          <tr><td class="p-3 bold">{{'preview.createdAt' | transloco}}</td><td>{{1638426022000 | customDate}}</td></tr>
          <tr><td class="p-3 bold">{{'preview.timezone' | transloco}}</td><td>Europe/Madrid</td></tr>
          <tr><td class="p-3 bold">{{'preview.lastValueReported' | transloco}}</td><td>{{1641985726000 | customDate}}</td></tr>
        </table>
      </div>
    </div>
    <div class="col-12 xl:col-4 pb-0">
      <div class="card main-height flex flex-column">
        <div class="card-header pt-1"><h4 class="mb-1">{{'preview.availableData' | transloco}} </h4></div>
        <hr>
        <div class="flex flex-column justify-content-center flex-1">
          <div class="text-center">
            <p class="m-0 bold">{{'preview.today' | transloco}}</p>
            <p style="font-size: 12px">{{'preview.totalSignalsWithData' | transloco}}</p>
            <div [style.font-size]="'40px'">
              <p class="inline" style="color: var(--primary-color-preview);">9</p>
              <p class="inline"> / 15</p>
            </div>
          </div>
          <div class="text-center mt-4">
            <p class="m-0 bold">{{'preview.total' | transloco}}</p>
            <p style="font-size: 12px">{{'preview.totalSignalsWithData' | transloco}}</p>
            <div [style.font-size]="'40px'">
              <p class="inline" style="color: var(--primary-color-preview);">14</p>
              <p class="inline"> / 15</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
